<script>
    export default {
        name: "ProductCardOptions",
        props: {
            disabled: Array,
        },
        computed: {
            options() {
                return ["USB TYPE–C", "Bluetooth", "Аккумулятор"];
            },
        },
    };
</script>

<template>
    <div class="product-card-options">
        <div
            class="product-card-option"
            :class="{ 'is-disabled': disabled.includes(option) }"
            v-for="(option, index) in options"
            :key="index"
        >
            {{ option }}
        </div>
    </div>
</template>

<style lang="scss">
    .product-card-options {
        display: flex;
        margin: 0 -2px;
        @include bp($bp-desktop-sm) {
            margin: 0 -5px;
        }
    }

    .product-card-option {
        margin: 0 2px;
        padding: 4px 7px;
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        text-align: center;
        border-radius: 25px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        &.is-disabled {
            color: #b0b0b0;
            text-decoration: line-through;
            border-color: #b0b0b0;
        }
        @include bp($bp-desktop-sm) {
            margin: 0 5px;
            padding: 8px 13px;
            font-size: 14px;
            line-height: 18px;
        }
    }
</style>
